import React from "react";
import PropTypes from "prop-types";

//
import ImageBox from "../general/ImageBox";
import NothingToShow from "../general/NothingToShow";

//
import { iconImage } from "../../redux/features/coins/actions";

function StatisticsInfo({ data }) {
  return (
    <div className="statistic">
      {data.best ? (
        <>
          <h6 className="mb-2">USDT</h6>
          <div className="items">
            <div className="item">
              <div className="holder">
                <p className="fw-extra-bolder text-black">All Time Profit</p>
                <small
                  className={`fw-bolder ${
                    +data?.total?.USDT > 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {+data?.total?.USDT > 0 && "+"}
                  {data?.total?.USDT}%
                </small>
              </div>
            </div>

            <div className="item">
              <ImageBox src={iconImage(data?.best?.USDT?.symbol)} />
              <div className="holder">
                <p className="fw-extra-bolder text-black">Best Performer</p>
                <div className="d-flex justify-content-end flex-wrap">
                  <small
                    className={`fw-bolder ${
                      +data.best.USDT?.benefitPercent > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {+data.best.USDT?.benefitPercent > 0 && "+"}
                    {data.best.USDT?.benefitPercent}%
                  </small>

                  <small
                    className={`fw-bolder ${
                      +data?.best?.USDT?.benefit > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    ({+data?.best?.USDT?.benefit > 0 && "+ "}$
                    {data?.best?.USDT?.benefit})
                  </small>
                </div>
              </div>
            </div>

            <div className="item">
              <ImageBox src={iconImage(data?.worst?.USDT?.symbol)} />
              <div className="holder">
                <p className="fw-extra-bolder text-black">Worst Performer</p>
                <div className="d-flex justify-content-end flex-wrap">
                  <small
                    className={`fw-bolder ${
                      +data?.worst?.USDT?.benefitPercent > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {+data?.worst?.USDT?.benefitPercent > 0 && "+"}
                    {data?.worst?.USDT?.benefitPercent}%
                  </small>

                  <small
                    className={`fw-bolder ${
                      +data?.worst?.USDT?.benefit > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    ({+data?.worst?.USDT?.benefit > 0 && "+ "}$
                    {data?.worst?.USDT?.benefit})
                  </small>
                </div>
              </div>
            </div>
          </div>

          <h6 className="mb-2 mt-4">BTC</h6>
          <div className="items">
            <div className="item">
              <div className="holder">
                <p className="fw-extra-bolder text-black">All Time Profit</p>
                <small
                  className={`fw-bolder ${
                    +data?.total?.BTC > 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {+data?.total?.BTC > 0 && "+"}
                  {data?.total?.BTC}%
                </small>
              </div>
            </div>

            <div className="item">
              <ImageBox src={iconImage(data?.best?.BTC?.symbol)} />
              <div className="holder">
                <p className="fw-extra-bolder text-black">Best Performer</p>
                <div className="d-flex justify-content-end flex-wrap">
                  <small
                    className={`fw-bolder ${
                      +data.best.BTC?.benefitPercent > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {+data.best.BTC?.benefitPercent > 0 && "+"}
                    {data.best.BTC?.benefitPercent}%
                  </small>

                  <small
                    className={`fw-bolder ${
                      +data?.best?.BTC?.benefit > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    ({+data?.best?.BTC?.benefit > 0 && "+ "}$
                    {data?.best?.BTC?.benefit})
                  </small>
                </div>
              </div>
            </div>

            <div className="item">
              <ImageBox src={iconImage(data?.worst?.BTC?.symbol)} />
              <div className="holder">
                <p className="fw-extra-bolder text-black">Worst Performer</p>
                <div className="d-flex justify-content-end flex-wrap">
                  <small
                    className={`fw-bolder ${
                      +data?.worst?.BTC?.benefitPercent > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {+data?.worst?.BTC?.benefitPercent > 0 && "+"}
                    {data?.worst?.BTC?.benefitPercent}%
                  </small>

                  <small
                    className={`fw-bolder ${
                      +data?.worst?.BTC?.benefit > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    ({+data?.worst?.BTC?.benefit > 0 && "+ "}$
                    {data?.worst?.BTC?.benefit})
                  </small>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <NothingToShow text="No asset" />
      )}
    </div>
  );
}

StatisticsInfo.propTypes = {
  data: PropTypes.object.isRequired,
};

export default StatisticsInfo;
